export const SNACKBAR_BOTTOM_GAP = {
    MOBILE: '-8px',
    DESKTOP: '-50%',
}
